import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {isNumber} from 'lodash/fp';
import {ReactNode} from 'react';

type TreePickerControlsProps = {
  selectionCount?: number | string;
  selectionLabel?: ReactNode;
  onSelectAll: () => void;
  onSelectNone: () => void;
  hideSelectAll: boolean;
  isSelectAllDisabled: boolean;
  onApply: () => void;
  buttonSize?: 'small' | 'medium';
};

const SRoot = styled('div')(({theme}) => ({
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const SButtons = styled('div')(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(4),

  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
  },
}));

export function TreePickerControls({
  selectionCount,
  selectionLabel,
  onSelectAll,
  onSelectNone,
  hideSelectAll,
  isSelectAllDisabled,
  onApply,
  buttonSize = 'small',
}: TreePickerControlsProps) {
  const isApplyDisabled = !isNumber(selectionCount) || selectionCount === 0;

  return (
    <SRoot>
      <Typography variant='body3'>{selectionLabel ? selectionLabel : `Selected ${selectionCount}`}</Typography>

      <SButtons>
        {hideSelectAll || (
          <Button size={buttonSize} variant='text' onClick={onSelectAll} disabled={isSelectAllDisabled}>
            Select All Filtered
          </Button>
        )}
        <Button size={buttonSize} variant='text' disabled={selectionCount === 0} onClick={onSelectNone}>
          Clear
        </Button>
        <Button
          size={buttonSize}
          variant={isApplyDisabled ? 'text' : 'contained'}
          disabled={isApplyDisabled}
          onClick={onApply}
        >
          Apply
        </Button>
      </SButtons>
    </SRoot>
  );
}
